function Loading () {
    
    return (
        <div className="row wv-100 mh-100 p-0 m-0 position-fixed top-0 end-0 start-0 bottom-0"
            style={{zIndex: '300000'}}>    
            <div className="d-flex justify-content-center align-items-center" 
                style={{backgroundColor: 'rgb(0 0 0)' , opacity:0.900}}>
                <div className="spinner-grow text-lite rahpardaznet-loading-grow" role="status">
                <span className="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    )
}

export default Loading;